import p from './../permissions'

export default [
  {
    icons: {
      menu: 'fal fa-map-marker',
      dashboard: 'fal fa-map-marker-alt'
    },
    title: 'Map',
    componentName: 'map',
    permission: p.map,
    button: {
      text: 'Open map',
      url: { name: 'map' }
    }
  },
  {
    icons: {
      menu: 'fal fa-file-plus',
      dashboard: 'fal fa-file-plus'
    },
    title: 'Install Devices',
    componentName: 'installDevices',
    permission: p.installDevices,
    button: {
      text: 'Open install devices',
      url: { name: 'install-devices' }
    }
  },
  {
    icons: {
      menu: 'fal fa-info-circle',
      dashboard: 'fal fa-info-circle'
    },
    title: 'Information',
    componentName: 'information',
    permission: p.information,
    button: {
      text: 'Open information',
      url: { name: 'information' }
    }
  },
  {
    icons: {
      menu: 'fal fa-file-alt',
      dashboard: 'fal fa-file-alt'
    },
    title: 'Reports',
    componentName: 'reports',
    permission: p.reports,
    button: {
      text: 'Open Reports',
      url: { name: 'reports' }
    }
  },
  {
    icons: {
      menu: 'fal fa-user-secret',
      dashboard: 'fal fa-user-secret'
    },
    title: 'Missing',
    componentName: 'missing',
    permission: p.missingEntities,
    button: {
      text: 'View cases',
      url: { name: 'missing' }
    }
  },
  {
    icons: {
      menu: 'fal fa-building',
      dashboard: 'fal fa-building'
    },
    title: 'Businesses',
    componentName: 'Businesses',
    permission: p.businesses,
    button: {
      text: 'Open Businesses',
      url: { name: 'businesses' }
    }
  },
  {
    icons: {
      menu: 'fal fa-user-friends',
      dashboard: 'fal fa-user-friends'
    },
    title: 'users',
    componentName: 'users',
    permission: p.users,
    button: {
      text: 'Open Users',
      url: { name: 'users' }
    }
  },
  {
    icons: {
      menu: 'fal fa-bicycle',
      dashboard: 'fal fa-bicycle'
    },
    title: 'Entities',
    componentName: 'entities',
    permission: p.entities,
    button: {
      text: 'Open Entities',
      url: { name: 'entities' }
    }
  },
  {
    icons: {
      menu: 'fal fa-wrench',
      dashboard: 'fal fa-wrench'
    },
    title: 'Maintenance Plans',
    componentName: 'maintenancePlans',
    permission: p.maintenancePlans,
    button: {
      text: 'Open Maintenance Plans',
      url: { name: 'maintenance-plans' }
    }
  },
  {
    icons: {
      menu: 'fal fa-comment-alt-dots',
      dashboard: 'fal fa-comment-alt-dots'
    },
    title: 'Notifications',
    componentName: 'notifications',
    permission: p.notifications,
    button: {
      text: 'Open Notifications',
      url: { name: 'notifications' }
    }
  },
  // {
  //   icons: {
  //     menu: 'fal fa-tablet-rugged',
  //     dashboard: 'fal fa-tablet-rugged'
  //   },
  //   title: 'Devices',
  //   componentName: 'devices',
  //   permission: p.devices,
  //   button: {
  //     text: 'Open Devices',
  //     url: { name: 'devices' }
  //   }
  // },
  // {
  //   icons: {
  //     menu: 'fal fa-credit-card',
  //     dashboard: 'fal fa-credit-card'
  //   },
  //   title: 'Subscriptions',
  //   componentName: 'subscriptions',
  //   permission: p.subscriptions,
  //   button: {
  //     text: 'Open Subscriptions',
  //     url: { name: 'subscriptions' }
  //   }
  // },
  // {
  //   icons: {
  //     menu: 'fal fa-star',
  //     dashboard: 'fal fa-star'
  //   },
  //   title: 'Subscriptions Management',
  //   componentName: 'subscriptionManagement',
  //   permission: p.subscriptionManagement,
  //   button: {
  //     text: 'Open Subscriptions',
  //     url: { name: 'subscription-management' }
  //   }
  // },
  {
    icons: {
      menu: 'fal fa-shopping-bag',
      dashboard: 'fal fa-shopping-bag'
    },
    title: 'Shop',
    componentName: 'shop',
    permission: p.webshop,
    button: {
      text: 'Open Shop',
      url: { name: 'shop' }
    }
  }
]

